<template>
    <div class="imgSearch" :class="type === 1 ? 'imgSearchSpecail' : ''">
        <Upload
                :action="host"
                :before-upload="handleBeforeUpload"
                :on-success="handleSuccess"
                :on-progress="handleProgress"
                :on-format-error="handleFormatError"
                :on-exceeded-size="handleMaxSize"
                :on-error="handleError"
                :format="['jpg','jpeg','png']"
                :max-size="2048"
                :show-upload-list="false"
                type="select">
            <i v-if="!loading" class="iconfont icon-camera1 icon-camera1-main"></i>
            <img v-if="loading" src="../../images/Rolling.gif" alt="">
        </Upload>
    </div>
</template>

<script>
    import util from  '../../libs/util'
    import store from '../../store'
    import api from '../../api'
    export default {
        data() {
            return {
                host: util.baseAjaxUrl + '/designer_api/product_ai/upload_image',
                imgUrl: '',
                file: null,
                baseImgUrl: api.common.imgBaseUrl,
                hrefUrl: window.location.href.split('/')[5],
                loading: false
            }
        },

        props:{
            type: {
                type: Number,
                default: 0
            }
        },

        methods:{
            handleSuccess(data){
                if(this.type === 1){
                    this.$store.dispatch('imgSearch',data.data);
                    localStorage.setItem("imgSearchLocal", data.data);
                    this.loading = false;
                    this.$emit('changeImgSearch');
                    if(this.hrefUrl === 'product'){
                        window.location.href = process.env.VUE_APP_OLD_BASIC_URL+'/home/product/list?imgsearch=1';
                    }else if(this.hrefUrl === 'plan'){
                        window.location.href =process.env.VUE_APP_OLD_BASIC_URL+'/home/plan/list?imgsearch=1';
                    }else{
                        window.location.href = process.env.VUE_APP_OLD_BASIC_URL+'/home/inspiration/list?imgsearch=1';
                    }

                }else{
                    this.$store.dispatch('imgSearch', data.data);
                    localStorage.setItem("imgSearchLocal", data.data);
                    this.loading = false;
                    window.location.href = process.env.VUE_APP_OLD_BASIC_URL+'/home/product/list?imgsearch=1'
                }
            },
            newWin(url) {
                var a = document.createElement("a"); //创建a对象
                a.setAttribute("href", url);
                a.setAttribute("target", "_blank");
                a.setAttribute("id", "camnpr");
                document.body.appendChild(a);
                a.click(); //执行当前对象
            },
            handleProgress(progross){
                this.loading = true
            },
            handleBeforeUpload(file){
            },
            handleError(){
                this.$Message.error('上传失败,请重新上传');
            },
            handleFormatError(){
                this.$Message.error('请选择 jpg,jpeg 或 png 格式的文件');
            },
            handleMaxSize(){
                this.$Message.error('请选择小于 2M 的图片');
            },
        },
        created() {

        }
    }
</script>

<style rel="stylesheet/scss" lang="scss">
    .imgSearch{
        font-size: 23px;
        position: absolute;
        color:#A2A2A8;
        right: 85px;
        top: 20px;
        z-index: 200;
        cursor: pointer;
        .icon-camera1-main{
            font-size: 23px;
            color:#A2A2A8;
        }
        .icon-camera1-main:hover{
            opacity: 0.8;
        }
        img{
            display: inline-block;
            width: 30px;
            height: 30px;
            margin-top: 4px;
        }
    }
    .imgSearchSpecail{
        right: 25px;
        top: 1px;
    }
</style>